import paths from './constants/paths';

export default {
  // overrides timeout value from default http client
  overrideHttpOpts: {
    timeout: 30000,
  },
  paths,
};
